import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-cpu-chip-01',
  standalone: true,
  templateUrl: './rt-icon-cpu-chip-01.component.html',
  styleUrls: ['./rt-icon-cpu-chip-01.component.scss']
})
export class RtIconCpuChip01Component {
  @Input() width: number | string = 17;
  @Input() height: number | string = 17;
}
